<template>
  <div
    class="event"
    :key="key"
    :class="{
      started: started,
      ended: ended,
      [eventType]: true,
      'predict-node': predict
    }"
    :style="nodeStyle"
  >
    <img :src="src" alt="" />

    <span class="label">{{ label }}</span>
  </div>
</template>

<script>
  import getNodeMixin from '../mixins/getNode'
  import StartEvent from '../svg/StartEvent.svg'
  import EndEvent from '../svg/EndEvent.svg'
  export default {
    name: 'Event',
    mixins: [getNodeMixin],
    computed: {
      eventType() {
        return this.data?.type || 'StartEvent'
      },
      isStartEvent() {
        return this.eventType === 'StartEvent'
      },
      src() {
        return this.isStartEvent ? StartEvent : EndEvent
      },
      flowStatus() {
        return this.data?.status
      },
      started() {
        return !!this.flowStatus
      },
      ended() {
        return this.flowStatus === 'end'
      },
      label() {
        return this.data?.label
      },
    },
  }
</script>

<style lang="scss" scoped>
  .event {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    opacity: 0.3;

    &.predict-node {
      opacity: 0.6;
    }

    img {
      width: 100%;
      height: 100%;
    }

    &.StartEvent {
      &.started {
        opacity: 1;
      }
    }

    &.EndEvent {
      &.ended {
        opacity: 1;
      }
    }

    .label {
      position: absolute;
      top: calc(100% + 8px);
      left: 50%;
      font-size: 12px;
      white-space: nowrap;
      transform: translateX(-50%);
    }
  }
</style>
